[
  { "code": "SGG1", "name": "Acids" },
  { "code": "SGG2", "name": "Ammonium compounds" },
  { "code": "SGG3", "name": "Bromates" },
  { "code": "SGG4", "name": "Chlorates" },
  { "code": "SGG5", "name": "Chlorites" },
  { "code": "SGG6", "name": "Cyanides" },
  {
    "code": "SGG7",
    "name": "Heavy metals and their salts (including their organometallic compounds)"
  },
  { "code": "SGG8", "name": "Hypochlorites" },
  { "code": "SGG9", "name": "Lead and its compounds" },
  { "code": "SGG10", "name": "Liquid halogenated hydrocarbons" },
  { "code": "SGG11", "name": "Mercury and mercury compounds" },
  { "code": "SGG12", "name": "Nitrites and their mixtures" },
  { "code": "SGG13", "name": "Perchlorates" },
  { "code": "SGG14", "name": "Permanganates" },
  { "code": "SGG15", "name": "Powdered metals" },
  { "code": "SGG16", "name": "Peroxides" },
  { "code": "SGG17", "name": "Azides" },
  { "code": "SGG18", "name": "Alkalis" }
]
